export default "__VITE_ASSET__DIc7yEhF__"